import { computed, ref } from 'vue';
import { IImport, ImportStatuses } from '@/models/imports.interface';
import { UTCDateTime } from '@studyportals/mb-platform-date-time';
import { Routes } from '@/models/router/router.interface';
import store from '@/store';
import importedDataPresenter from '@/presenters/imported-data-presenter';

export default class OverviewCode {
	private limit = ref(5);
	public storedImports = computed((): IImport[] => {
		return store.getters.storedImports();
	});

	public doesAmountOfImportsExceedLimit = computed((): boolean => {
		return this.storedImports.value.length > this.limit.value;
	});

	public async prepareUploads(): Promise<void> {
		await importedDataPresenter.getAllUploads();
	}

	public shouldEntryBeShown(index: number): boolean {
		return index < this.limit.value;
	}

	public shouldRefreshButtonBeShown(storedImport: IImport): boolean {
		return storedImport.status === ImportStatuses.PENDING || storedImport.status === ImportStatuses.PROCESSING;
	}

	public shouldErrorDetailsButtonBeShown(storedImport: IImport): boolean {
		return storedImport.status === ImportStatuses.FAILED || storedImport.status === ImportStatuses.PARTIALLY_FAILED;
	}

	public getLabelOfStatus(status: ImportStatuses): string {
		switch (status) {
			case ImportStatuses.PENDING:
				return 'Pending';
			case ImportStatuses.PROCESSING:
				return 'Processing';
			case ImportStatuses.COMPLETED:
				return 'Completed';
			case ImportStatuses.FAILED:
				return 'Failed';
			case ImportStatuses.PARTIALLY_FAILED:
				return 'Partially failed';
			default:
				return '';
		}
	}

	public convertTimestampToDateString(timestamp: number): string {
		if (!timestamp) {
			return '';
		}

		const date = new UTCDateTime(new Date(timestamp));
		return date.toString().substring(4, 26);
	}

	public increaseLimit(): void {
		this.limit.value += 5;
	}

	public async updateStatus(storedImport: IImport): Promise<void> {
		await importedDataPresenter.getSpecificUpload(storedImport);
	}

	public showErrorDetails(id: string): void {
		store.mutations.setCurrentRoute(Routes.ERROR_DETAILS, id);
	}
}
